import type { PartDefinition } from '../catalog/part-definition'

export function PartVisual({ part, large = false }: { part: PartDefinition; large?: boolean }) {
  if (part.thumbnailUrl) {
    return (
      <div className={`part-visual part-preview ${large ? 'large' : ''}`}>
        <img src={part.thumbnailUrl} alt="" draggable={false} />
      </div>
    )
  }
  return (
    <div className={`part-visual ${large ? 'large' : ''}`} style={{ '--part-color': part.color } as React.CSSProperties}>
      <span className="part-top" />
      <span className="part-front"><i /><i /></span>
      <span className="part-side" />
      {part.kind === 'link' && <b className="part-link" />}
    </div>
  )
}
